import axios from "axios";

export const login = async (id, pw) => {
    const data = await axios.post(`/api/login?id=${id}&password=${pw}`);
    return data;
};

export const logout = async () => {
    const data = await axios.post(`/api/logout`);
    return data;
};

export const checkSession = async () => {
    const data = await axios
        .get(`/api/session`)
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                window.location.href = `/admin/login`;
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
    return data;
};
